<div class="premium-breakup-main-dialog" mat-dialog-content>
  <div class="d-flex justify-content-between">
    <img [src]="initiateQuotes.insurer_logo" class="insurer-logo" />
    <div *ngIf="thirdParty != 'bundled_tp'">
      <p class="cover-text">Total Cover (IDV)</p>
      <p class="cover-amount">
        &#8377;
        {{
          initiateQuotes.premium_details.idv != 0
            ? (initiateQuotes.premium_details.idv | number : "2.")
            : 0
        }}
      </p>
    </div>

    <div class="cross-btn">
      <div
        class="d-flex justify-content-end"
        (click)="cancelBreakupPremium($event)"
      >
        <img src="assets/icon/cross.svg" alt="" class="cross-icon me-3" />
      </div>
    </div>
  </div>
  <div>
    <div class="d-flex justify-content-between mt-2">
      <span class="d-flex justify-content-start own-damage-text text-bold">
        Total Own Damage (A)
      </span>
      <span class="d-flex justify-content-end own-damage-amount text-bold">
        &#8377;
        {{
          initiateQuotes.premium_details.od_premium_details.total_od_premium !=
          0
            ? (initiateQuotes.premium_details.od_premium_details
                .total_od_premium | number : "2.")
            : 0
        }}
      </span>
    </div>
    <!-- <div class="d-flex justify-content-between">
      <span class="own-damage-text"> Basic Own Damage </span>
      <span class="own-damage-amount">
        &#8377;
        {{
          initiateQuotes.premium_details.od_premium_details.basic_od_premium
           | number : "2."
        }}
      </span>
    </div> -->
    <div
      class="d-flex justify-content-between"
      *ngIf="!mmvParseData?.previous_claimed"
    >
      <span class="own-damage-text"> NCB Discount </span>
      <span class="own-damage-amount"
        ><span
          *ngIf="
            initiateQuotes.premium_details.od_premium_details.ncb_discount != 0
          "
          >-</span
        >
        &#8377;
        {{
          initiateQuotes.premium_details.od_premium_details.ncb_discount < 0
            ? (-initiateQuotes.premium_details.od_premium_details.ncb_discount
              | number : "2.")
            : (initiateQuotes.premium_details.od_premium_details.ncb_discount
              | number : "1.")
        }}</span
      >
    </div>
  </div>

  <div class="d-flex justify-content-between mt-2">
    <span class="own-damage-text text-bold"> Third Party (B)</span>
    <span class="own-damage-amount text-bold">
      &#8377;
      {{
        initiateQuotes.premium_details.tp_premium_details.total_tp_premium != 0
          ? (initiateQuotes.premium_details.tp_premium_details.total_tp_premium
            | number : "2.")
          : 0
      }}
    </span>
  </div>
  <div class="d-flex justify-content-between mt-2">
    <span class="own-damage-text text-bold">
      <div class="d-flex cursor-pointer" (mouseenter)="showCard = true"
      (mouseleave)="showCard = false">
        Total Addons
        {{ initiateQuotes.premium_details?.is_addon_addition ? "(D)" : "" }}
        <img
          src="assets/icon/cpa-hover.svg"
          
          alt=""
          class="addons-hover-image ms-2"
          *ngIf="
            initiateQuotes?.premium_details?.addon_premium_details.length != 0
          "
        />
        <img
          src="assets/icon/cpa-hover.svg"
          (click)="showAddonsData()"
          alt=""
          class="res-addons-hover-image"
        />
      </div>
      <span class="included-text">(included with OD & TP)</span>
    </span>
    <span class="own-damage-amount text-bold">
      &#8377;
      {{
        initiateQuotes?.premium_details?.total_addon_premium !== 0
          ? (initiateQuotes?.premium_details?.total_addon_premium
            | number : "2.")
          : 0
      }}
    </span>
  </div>
  <ng-container
    *ngIf="
      showAddons &&
      initiateQuotes?.premium_details?.addon_premium_details.length > 0
    "
    class="addons-res"
  >
    <div
      class="d-flex justify-content-between"
      *ngFor="
        let addOns of initiateQuotes?.premium_details?.addon_premium_details
      "
    >
      <span class="own-damage-text"> {{ addOns?.add_on_name }} </span>
      <span
        class="own-damage-amount"
        *ngIf="!(addOns?.is_offered && addOns?.add_on_premium == 0)"
      >
        &#8377; {{ addOns?.add_on_premium }}
      </span>
      <span
        *ngIf="addOns?.is_offered && addOns?.add_on_premium == 0"
        class="included"
        >Included</span
      >
    </div>
  </ng-container>

  <div
    class="d-flex justify-content-end"
    *ngIf="
      showCard &&
      initiateQuotes?.premium_details?.addon_premium_details.length > 0  && windowlength>=999
    "
  >
    <div
      [ngClass]="
        initiateQuotes?.premium_details?.addon_premium_details.length > 5
          ? 'addons-card-popup'
          : 'Zero-addons'
      "
      class="addons-card-popup"
    >
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="d-flex justify-content-between mb-2">
              <span class="own-damage-text text-bold"> Total Addons </span>
              <span class="own-damage-amount text-bold">
                &#8377;
                {{
                  initiateQuotes?.premium_details?.total_addon_premium != 0
                    ? (initiateQuotes?.premium_details?.total_addon_premium
                      | number : "2.")
                    : 0
                }}
              </span>
            </div>
            <div
              class="d-flex justify-content-between"
              *ngFor="
                let addOns of initiateQuotes?.premium_details
                  ?.addon_premium_details
              "
            >
              <span class="own-damage-text"> {{ addOns?.add_on_name }} </span>
              <span
                class="own-damage-amount addons-value"
                *ngIf="!(addOns?.is_offered && addOns?.add_on_premium == 0)"
              >
                &#8377; {{ addOns?.add_on_premium }}
              </span>
              <span
                *ngIf="addOns?.is_offered && addOns?.add_on_premium == 0"
                class="included"
                >Included</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between mt-2">
    <span class="own-damage-text text-bold"> GST (18%) (C) </span>
    <span class="own-damage-amount text-bold">
      &#8377;
      {{
        initiateQuotes.premium_details.total_gst != 0
          ? (initiateQuotes.premium_details.total_gst | number : "2.")
          : 0
      }}
    </span>
  </div>

  <div class="d-flex justify-content-between mt-2">
    <span class="own-damage-text text-bold">
      Total Premium (A+B+C{{
        initiateQuotes.premium_details?.is_addon_addition ? "+D" : ""
      }})
    </span>

    <span class="own-damage-amount text-bold">
      &#8377;
      {{
        initiateQuotes.premium_details.gross_premium != 0
          ? (initiateQuotes.premium_details.gross_premium | number : "2.")
          : 0
      }}
    </span>
  </div>

  <div class="row share-download-btn mt-2">
    <div class="col-12">
      <div class="communication-group d-flex">
        <div
          class="share-group light-blue d-flex justify-content-center"
          (click)="shareQuotes()"
        >
          <img src="assets/icon/share.svg" class="share-icon" />
          <p class="share-text text-light-blue">Share</p>
        </div>
        <div class="download-group light-green justify-content-center d-flex">
          <img
            src="assets/icon/download.svg"
            class="download-icon"
            *ngIf="!downloadLoader"
          />
          <p
            class="download-text text-light-green"
            (click)="downloadPremiumBreakup(initiateQuotes)"
            *ngIf="!downloadLoader"
          >
            Download
          </p>
          <img
            class="loader"
            src="assets/gif/downloadLoader.gif"
            alt=""
            *ngIf="downloadLoader"
          />
        </div>
        <div></div>
      </div>
    </div>
  </div>
  <div class="share-download-btn-res mt-2">
    <div class="row" *ngIf="endPath == 'quotes'">
      <div class="col-3">
        <button mat-button class="light-blue" (click)="shareQuotes()">
          <img src="assets/icon/share.svg" class="share-icon" alt="" />
        </button>
      </div>
      <div class="col-3">
        <button
          mat-button
          class="light-green"
          *ngIf="!downloadLoader"
          (click)="downloadPremiumBreakup(initiateQuotes)"
        >
          <img src="assets/icon/download.svg" class="share-icon" alt="" />
        </button>
        <div class="light-green text-center p-2" *ngIf="downloadLoader">
          <img
            class="loader-download"
            src="assets/gif/downloadLoader.gif"
            alt=""
          />
        </div>
      </div>
      <div class="col-6" *ngIf="endPath == 'quotes'">
        <button
          mat-button
          class="submit-btn"
          (click)="getProposalDetails(initiateQuotes)"
        >
          Buy Now
        </button>
      </div>
    </div>
    <div *ngIf="endPath != 'quotes'">
      <div class="">
        <div class="communication-group row">
          <div
            class="share-group col-6 light-blue d-flex justify-content-center"
            (click)="shareQuotes()"
          >
            <img src="assets/icon/share.svg" class="share-icon" />
            <p class="share-text text-light-blue">Share</p>
          </div>
          <div
            class="download-group col-6 light-green justify-content-center d-flex"
          >
            <img
              src="assets/icon/download.svg"
              class="download-icon"
              *ngIf="!downloadLoader"
            />
            <p
              class="download-text text-light-green"
              *ngIf="!downloadLoader"
              (click)="downloadPremiumBreakup(initiateQuotes)"
            >
              Download
            </p>
            <img
              class="loader"
              src="assets/gif/downloadLoader.gif"
              alt=""
              *ngIf="downloadLoader"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
